import { AudienceDto } from "@intelligems/ig-types";

export const formatAudienceDto = (
  audience: AudienceDto
): AudienceDto | undefined => {
  if (!audience) return undefined;

  return {
    ...audience,
    elseAction: audience.filters.length === 0 ? null : audience.elseAction,
    elseVariationId:
      audience.filters.length === 0 ? null : audience.elseVariationId,
    audienceType:
      audience.filters.length === 0 && audience.audienceType !== "common"
        ? "common"
        : audience.audienceType,
  };
};
